import { Building2, Link2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export function UniversePrompt({ open, onOpenChange, company, matches = [], onPick, onAdd, entityLabel = "lead" }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="universe-required-prompt">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <Building2 className="h-4 w-4 text-amber-500" /> Company not in the Universe
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">
          Every {entityLabel} must be linked to a parent company in the <span className="font-semibold">Universe</span>.
          “<span className="font-semibold">{company}</span>” was not found — add it now, or link one of the matches below.
        </p>
        {matches.length > 0 && (
          <div className="space-y-1.5">
            <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Did you mean one of these?</p>
            {matches.slice(0, 4).map((m) => (
              <button key={m.id} type="button" onClick={() => onPick(m)}
                className="w-full text-left flex items-center gap-2 text-sm text-slate-700 bg-slate-50 hover:bg-emerald-50 hover:text-emerald-800 border border-slate-200 rounded-md px-3 py-2 transition-colors"
                data-testid={`universe-prompt-match-${m.id}`}>
                <Link2 className="h-3.5 w-3.5 flex-shrink-0 text-slate-400" />
                <span className="truncate">
                  <span className="font-medium">{m.company}</span>
                  {m.location ? ` · ${m.location}` : ""}{m.category ? ` · Class ${m.category}` : ""}
                </span>
              </button>
            ))}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="universe-prompt-cancel">Cancel</Button>
          <Button onClick={onAdd} className="bg-slate-900 hover:bg-slate-800 gap-1.5" data-testid="universe-prompt-add-btn">
            <Plus className="h-4 w-4" /> Add “{company}” to Universe
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
